import React from 'react';
import { ChangelogPimple } from './ChangelogPimple';
import { Text } from 'wix-style-react';
import style from './TreeSectionTitle.scss';

export const SectionTitleContent = ({ shouldShowPimple, type, title }) => (
  <>
    {shouldShowPimple && <ChangelogPimple className={style.notificationIcon} />}
    <Text
      className={style.textContainer}
      ellipsis
      tagName="h6"
      weight="bold"
      placement="right"
      dataHook={`${type}-section-title-text`}
    >
      {title}
    </Text>
  </>
);
